import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 17H16M11.0177 2.76401L4.23539 8.03914C3.78202 8.39176 3.55534 8.56807 3.39203 8.78887C3.24737 8.98446 3.1396 9.2048 3.07403 9.43907C3 9.70354 3 9.99071 3 10.5651V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V10.5651C21 9.99071 21 9.70354 20.926 9.43907C20.8604 9.2048 20.7526 8.98446 20.608 8.78887C20.4447 8.56807 20.218 8.39176 19.7646 8.03914L12.9823 2.76402C12.631 2.49076 12.4553 2.35414 12.2613 2.30162C12.0902 2.25528 11.9098 2.25528 11.7387 2.30162C11.5447 2.35414 11.369 2.49076 11.0177 2.76401Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 13V15M10 9V15M14 5V15M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2 12L11.6422 16.8211C11.7734 16.8867 11.839 16.9195 11.9078 16.9324C11.9687 16.9438 12.0313 16.9438 12.0922 16.9324C12.161 16.9195 12.2266 16.8867 12.3578 16.8211L22 12M2 17L11.6422 21.8211C11.7734 21.8867 11.839 21.9195 11.9078 21.9324C11.9687 21.9438 12.0313 21.9438 12.0922 21.9324C12.161 21.9195 12.2266 21.8867 12.3578 21.8211L22 17M2 7L11.6422 2.17888C11.7734 2.11329 11.839 2.0805 11.9078 2.06759C11.9687 2.05616 12.0313 2.05616 12.0922 2.06759C12.161 2.0805 12.2266 2.11329 12.3578 2.17888L22 7L12.3578 11.8211C12.2266 11.8867 12.161 11.9195 12.0922 11.9324C12.0313 11.9438 11.9687 11.9438 11.9078 11.9324C11.839 11.9195 11.7734 11.8867 11.6422 11.8211L2 7Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 12H18L15 21L9 3L6 12H2",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 2C13.3132 2 14.6136 2.25866 15.8268 2.76121C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7363 6.95991 21.2388 8.17317C21.7413 9.38643 22 10.6868 22 12M12 2V12M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5229 22 12M12 2C17.5228 2 22 6.47716 22 12M22 12L12 12M22 12C22 13.5781 21.6265 15.1338 20.9101 16.5399C20.1936 17.946 19.1546 19.1626 17.8779 20.0902L12 12",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 6,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 7,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 8,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 9,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 10,
  class: "text-transparent",
  width: "61",
  height: "60",
  viewBox: "0 0 61 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<rect x=\"0.898438\" y=\"0.238281\" width=\"59.7556\" height=\"59.7556\" rx=\"13.8258\" fill=\"#1570EF\"></rect><path d=\"M9.03931 19.2509C9.03931 13.2503 13.9038 8.38574 19.9045 8.38574V19.2509H9.03931Z\" fill=\"white\"></path><path d=\"M9.03931 40.98H19.9045V51.8452C13.9038 51.8452 9.03931 46.9807 9.03931 40.98Z\" fill=\"white\"></path><path d=\"M30.7705 19.25C36.7712 19.25 41.6357 24.1145 41.6357 30.1152H30.7705V19.25Z\" fill=\"white\"></path><path d=\"M30.7705 30.1172H41.6357C41.6357 36.1179 36.7712 40.9824 30.7705 40.9824V30.1172Z\" fill=\"white\"></path><path d=\"M19.9075 30.1152C19.9075 24.1145 24.772 19.25 30.7727 19.25V30.1152H19.9075Z\" fill=\"white\"></path><path d=\"M19.9075 30.1172H30.7727V40.9824C24.772 40.9824 19.9075 36.1179 19.9075 30.1172Z\" fill=\"white\"></path><path d=\"M41.6387 8.38574C47.6394 8.38574 52.5039 13.2503 52.5039 19.2509H41.6387V8.38574Z\" fill=\"white\"></path><path d=\"M9.03784 30.1152C9.03784 24.1145 13.9024 19.25 19.903 19.25V30.1152H9.03784Z\" fill=\"white\"></path><path d=\"M9.03784 30.1143H19.903V40.9795C13.9024 40.9795 9.03784 36.1149 9.03784 30.1143Z\" fill=\"white\"></path><path d=\"M41.6323 19.25C47.633 19.25 52.4975 24.1145 52.4975 30.1152H41.6323V19.25Z\" fill=\"white\"></path><path d=\"M41.6323 30.1143H52.4975C52.4975 36.1149 47.633 40.9795 41.6323 40.9795V30.1143Z\" fill=\"white\"></path><path d=\"M30.7661 51.8457C24.7654 51.8457 19.9009 46.9812 19.9009 40.9805L30.7661 40.9805L30.7661 51.8457Z\" fill=\"white\"></path><path d=\"M30.769 51.8457L30.769 40.9805L41.6342 40.9805C41.6342 46.9812 36.7697 51.8457 30.769 51.8457Z\" fill=\"white\"></path><path d=\"M19.9009 19.2515C19.9009 13.2508 24.7654 8.38626 30.7661 8.38626L30.7661 19.2515L19.9009 19.2515Z\" fill=\"white\"></path><path d=\"M30.769 19.2515L30.769 8.38626C36.7697 8.38626 41.6342 13.2508 41.6342 19.2515L30.769 19.2515Z\" fill=\"white\"></path><path d=\"M41.6387 40.98H52.5039C52.5039 46.9807 47.6394 51.8452 41.6387 51.8452V40.98Z\" fill=\"white\"></path>", 17)
const _hoisted_50 = [
  _hoisted_33
]
const _hoisted_51 = {
  key: 11,
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<rect x=\"0.046875\" y=\"0.238281\" width=\"59.8803\" height=\"59.7559\" rx=\"13.8259\" fill=\"#099250\"></rect><ellipse cx=\"15.4685\" cy=\"15.6311\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"29.984\" cy=\"15.6311\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"44.505\" cy=\"15.6311\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"15.4685\" cy=\"30.1179\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"44.505\" cy=\"30.1179\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"30.1098\" cy=\"30.1179\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"15.4685\" cy=\"44.6032\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"29.984\" cy=\"44.6032\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"44.4995\" cy=\"44.6032\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse>", 10)
const _hoisted_62 = [
  _hoisted_52
]
const _hoisted_63 = {
  key: 12,
  viewBox: "0 0 22 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7 5V4M7 9.5V8.5M7 14V13M5.8 17H16.2C17.8802 17 18.7202 17 19.362 16.673C19.9265 16.3854 20.3854 15.9265 20.673 15.362C21 14.7202 21 13.8802 21 12.2V5.8C21 4.11984 21 3.27976 20.673 2.63803C20.3854 2.07354 19.9265 1.6146 19.362 1.32698C18.7202 1 17.8802 1 16.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V12.2C1 13.8802 1 14.7202 1.32698 15.362C1.6146 15.9265 2.07354 16.3854 2.63803 16.673C3.27976 17 4.11984 17 5.8 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = {
  key: 13,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.0786 9.35766C5.0268 9.02385 4.99993 8.68187 4.99993 8.33366C4.99993 4.65176 8.00433 1.66699 11.7105 1.66699C15.4166 1.66699 18.421 4.65176 18.421 8.33366C18.421 9.16539 18.2677 9.96154 17.9876 10.6957C17.9294 10.8482 17.9003 10.9245 17.8871 10.984C17.874 11.043 17.869 11.0845 17.8676 11.1449C17.8661 11.2058 17.8744 11.273 17.8909 11.4073L18.2264 14.1324C18.2627 14.4274 18.2809 14.5749 18.2318 14.6822C18.1888 14.7761 18.1125 14.8508 18.0175 14.8916C17.9092 14.9382 17.7621 14.9166 17.4681 14.8735L14.8137 14.4844C14.6751 14.4641 14.6058 14.4539 14.5427 14.4543C14.4802 14.4547 14.437 14.4593 14.3759 14.4721C14.3142 14.4851 14.2353 14.5147 14.0774 14.5738C13.3414 14.8495 12.5436 15.0003 11.7105 15.0003C11.362 15.0003 11.0197 14.9739 10.6855 14.9231M6.35961 18.3337C8.83036 18.3337 10.8333 16.2816 10.8333 13.7503C10.8333 11.219 8.83036 9.16699 6.35961 9.16699C3.88886 9.16699 1.88592 11.219 1.88592 13.7503C1.88592 14.2592 1.96686 14.7486 2.11625 15.2059C2.1794 15.3992 2.21098 15.4959 2.22134 15.5619C2.23216 15.6309 2.23406 15.6696 2.23003 15.7393C2.22617 15.806 2.20947 15.8814 2.17608 16.0323L1.66663 18.3337L4.16229 17.9928C4.29851 17.9742 4.36662 17.9649 4.4261 17.9653C4.48873 17.9657 4.52196 17.9691 4.58338 17.9814C4.64171 17.993 4.72843 18.0236 4.90185 18.0848C5.35879 18.2461 5.84922 18.3337 6.35961 18.3337Z",
  stroke: "currentColor",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = {
  key: 14,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1040_5920)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0001 13.3334V10.0001M10.0001 6.66675H10.0084M18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1040_5920" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1)
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = {
  key: 15,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5M7.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H7.5",
  stroke: "#475467",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = {
  key: 16,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_78 = [
  _hoisted_77
]

import { defineOptions } from 'vue';


export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'RLIconComponent',
  props: {
  icon: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.icon == 'bold')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (props.icon == 'rl-overview')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (props.icon == 'rl-journeys')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true),
    (props.icon == 'rl-progress')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
      : _createCommentVNode("", true),
    (props.icon == 'rl-activity')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true),
    (props.icon == 'rl-reports')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
      : _createCommentVNode("", true),
    (props.icon == 'rl-students')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21))
      : _createCommentVNode("", true),
    (props.icon == 'rl-admin')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24))
      : _createCommentVNode("", true),
    (props.icon == 'rl-super-admin')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_27))
      : _createCommentVNode("", true),
    (props.icon == 'rl-internal')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_31))
      : _createCommentVNode("", true),
    (props.icon == 'rl-glasses')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_50))
      : _createCommentVNode("", true),
    (props.icon == 'rl-calculator')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_51, _hoisted_62))
      : _createCommentVNode("", true),
    (props.icon == 'rl-menu')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_63, _hoisted_65))
      : _createCommentVNode("", true),
    (props.icon == 'rl-chat-bubbles')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_66, _hoisted_68))
      : _createCommentVNode("", true),
    (props.icon == 'rl-info-circle')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_69, _hoisted_72))
      : _createCommentVNode("", true),
    (props.icon == 'rl-logout')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_73, _hoisted_75))
      : _createCommentVNode("", true),
    (props.icon == 'rl-class-reports')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_76, _hoisted_78))
      : _createCommentVNode("", true)
  ], 64))
}
}

})